import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Check, Flame, Medal } from "lucide-react";
import { TV } from "./TriviaTheme";
import { readStreak, SPORT_KEY } from "../lib/streak";
import { SportLeaderboard } from "./ChartLeaderboard";

export const SportThreeCard = () => {
  const nav = useNavigate();
  const [streak] = useState(() => readStreak(SPORT_KEY));
  return (
    <div className="mt-10">
    <div className={`${TV.green} p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4 tv-rise`} data-testid="sport-three-card">
      <div className="flex items-start gap-4">
        <span className="w-11 h-11 shrink-0 rounded-full bg-white/10 flex items-center justify-center"><Medal className="w-5 h-5" /></span>
        <div>
          <p className="tv-caps text-white/70">Free daily · 3 questions</p>
          <p className="font-ui font-bold text-2xl sm:text-3xl mt-1">Sport Three</p>
          <p className="font-ui text-[13px] text-white/75 mt-1">A World Cup, an Olympics and a US sports question. New every day.</p>
        </div>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <span data-testid="sport-streak" className="inline-flex items-center gap-1.5 bg-white/10 border border-white/20 rounded-full px-3 py-1.5 font-ui text-xs font-semibold">
          {streak.playedToday ? <Check className="w-3.5 h-3.5" /> : <Flame className="w-3.5 h-3.5" />}
          {streak.count ? `${streak.count}-day sport streak` : "Start a sport streak"}
        </span>
        <button data-testid="play-sport-three" onClick={() => nav("/trivia/play?source=sport-daily&mode=mc&count=3")}
          className="inline-flex items-center gap-1.5 bg-white text-[#161514] hover:bg-[#F4F1EA] rounded-full px-5 py-2.5 font-ui text-sm font-semibold transition-colors">
          {streak.playedToday ? "Play again" : "Play today's"} <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
    <div className="mt-3"><SportLeaderboard /></div>
    </div>
  );
};
